import React from "react";

import Image from "../Image";

import { IMobileLobbyState } from "@/modules/sharedState";
import Marquee from "@/modules/react-smooth-marquee";
import { defaultLogo } from "@/modules/commonMobile";
import { assetImg } from "@/modules/moduleImporter";
import moneyFormat from "@/modules/moneyFormat";
import { fetchUserData } from "./fetchAPIs";

import img_home_hamburger from "@/assets/img/svg/sidemenu/hamburger.svg";

interface IProps extends IMobileLobbyState {
	openSidebar: (e: any) => void;
}

interface IState {
	isRefreshingBalance: boolean
}

export default class Header extends React.Component<IProps, IState> {
	enableScrollingText = false;

	constructor(props) {
		super(props);

		this.state = {
			isRefreshingBalance: false
		};
	}

	private logoFragment() {
		const { userdata } = this.props;

		return (
			<a className="logo" href="/m">
				<Image className="img-logo"
					src={userdata.user.operatorLogo || defaultLogo}
					fallbackSrc={defaultLogo}
					alt="IDN Logo" />
			</a>
		);
	}

	fetchUserData = fetchUserData;

	private refreshBalance() {
		const { isRefreshingBalance } = this.state;

		if (!isRefreshingBalance)
			this.setState({ isRefreshingBalance: true }, () => {
				window.setTimeout(() =>
					this.setState({ isRefreshingBalance: false }),
					2000
				)
			});

		this.fetchUserData(null)
	}

	private userInfoFragment() {
		const { userdata } = this.props;

		if (!userdata)
			return null;

		const
			{ isRefreshingBalance } = this.state,
			{ displayNickname, balance, lang, currency } = userdata.user;

		return (
			<div className="user-info main-user-info">
				<div className="username">
					<span>
						{displayNickname}
					</span>
				</div>

				<div className="user-balance">
					<span>
						{moneyFormat(balance, lang, currency)}
					</span>

					<button
						className={"button-refresh-balance " + (isRefreshingBalance ? "spin" : "")}
						onClick={() => this.refreshBalance()}>

						{assetImg("sidemenu", "refresh.svg")}
					</button>
				</div>
			</div>
		);
	}

	private runningTextFragment() {
		const
			{ lang, userdata } = this.props,
			{ game } = userdata;

		return (
			<div className="running-text-box">
				<div className="label-info">
					<span>
						{lang["txt_info"]} :
					</span>
				</div>

				<div className="running-text-content">
					{
						this.enableScrollingText ? (
							//Running text
							<Marquee>
								{
									game.properties.map(item =>
										(item.type === "running-text")
											? item.content + "  "
											: null
									)
								}
							</Marquee>
						) : (
							<div>
								{
									userdata ?
										game.properties.map(item =>
											(item.type === "running-text")
												? item.content + "  "
												: null
										) : null
								}
							</div>
						)
					}
				</div>
			</div>
		);
	}

	private hamburgerFragment() {
		return (
			<div className="hamburger" onClick={this.props.openSidebar}>
				<img src={img_home_hamburger} alt="hamburger button" />
			</div>
		);
	}

	render() {
		return (
			<div className="box-header">
				<div className="header-top">
					{this.hamburgerFragment()}
					{this.logoFragment()}
					{this.userInfoFragment()}
				</div>

				{this.runningTextFragment()}
			</div>
		);
	}
}